import http from '@/utils/http/http'
// import { dataTool } from 'echarts'


//筛选条件
export function searchList (data) {
  return http.get('/sys/dict/data/dataList/'+ data)
}

//首页热点排行榜
export function hotPolicy () {
  
  // return http.get('/governmentApi/webReflect/hotPolicy')
}

// 最新政策列表
export function policyNews (data) {
  return http.post('/governmentApi/webReflect/policyByQuery', data, {form: true})
}


// 最新政策列表
export function policyDetail (data) {
  return http.get('/governmentApi/webReflect/policyDetail/'+data)
}

//查询收藏状态
export function getcollectionState (data) {
  return http.get('/governmentApi/webReflect/collectionState/'+data.comld+'/' + data.policyId)
}

//更改收藏状态
export function changeCollection (data) {
  return http.get('/governmentApi/webReflect/changeCollection/'+data.checkCollection+'/' + data.comld+'/' + data.policyId)
}


//首页echarts数据
export function statistics () {
  return http.get('/governmentApi/webReflect/statistics')
}